import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import { Helmet } from "react-helmet";

const Template = ({ pageTitle, children }) => {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      onContextMenu={(e) => e.preventDefault()}
    >
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      {children}
    </Box>
  );
};

Template.propTypes = {
  pageTitle: PropTypes.string,
  children: PropTypes.element.isRequired,
};

Template.defaultProps = {
  pageTitle: "Knightscope 3D",
};

export default Template;
